<ng-content></ng-content>
<div class="col-xs-12 col-md-12 hide-mobile no-padding">
    <div class="side-section-spc">
        <h5 class="coverage-amt-label bottom-spc-20 " [innerHTML]="contentHeader"></h5>
        <p class="popup-feature-content" [innerHTML]="content"></p>
        <img [src]="imageURL" class="tenure-img-spc" />
        <div id="p1"></div>
    </div>
</div>